import type { WireFrameExtractDialogResult } from './types';

export const WireFrameExtractSubmissionService = Symbol.for('WireFrameExtractSubmissionService');

export interface WireFrameExtractSubmissionService {
    handleSubmit(result: WireFrameExtractDialogResult, next: () => void): Promise<void>;
}
